import React from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { trackGiveSearchResultFeedback } from "../../../../utils/SearchTrackingUtil";

type Props = {
    onClose: () => void;
    show: boolean;
    container: React.Component<any>;
    searchFeedbackData: SearchFeedbackData;
};

type SearchFeedbackData = {
    employeeId: string | null | undefined;
    selectedCustomerId: string;
    resultIds: Array<string> | undefined | null; // BettyBundleIds of search results,
    numberOfSearchResults: number;
};

type State = {
    feedbackText: string | undefined | null;
};

class CreateSearchFeedbackModal extends React.Component<Props, State> {
    static contextTypes = {
        intl: PropTypes.object
    };
    state = {
        feedbackText: ""
    };

    handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        if (this.state.feedbackText && this.state.feedbackText !== "") {
            trackGiveSearchResultFeedback(
                this.state.feedbackText,
                window.location.search,
                this.props.searchFeedbackData.employeeId ?? "",
                this.props.searchFeedbackData.selectedCustomerId,
                this.props.searchFeedbackData.resultIds ?? [],
                this.props.searchFeedbackData.numberOfSearchResults
            );
        }
        this.props.onClose();
        return false;
    };

    handleFeedbackTextInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            feedbackText: e.target.value
        });
    };

    render() {
        return (
            <Modal
                container={this.props.container}
                keyboard
                animation
                onHide={this.props.onClose}
                show={this.props.show}
                className="ca-list-create-search-feedback-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FormattedMessage id="SD_SEND_SEARCH_RESULT_FEEDBACK_TITLE" />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form role="form" onSubmit={this.handleSubmit}>
                        <div className="form-group">
                            <input
                                type="text"
                                maxLength={1000}
                                className="form-control test-feedback-text"
                                autoFocus
                                placeholder={this.context.intl.formatMessage({
                                    id: "SD_SEND_SEARCH_RESULT_FEEDBACK_HINT"
                                })}
                                onChange={this.handleFeedbackTextInput}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={this.props.onClose}>
                        <FormattedMessage id="EX_CANCEL_MODAL" />
                    </button>
                    <button
                        type="submit"
                        value="create"
                        className="btn btn-primary test-submit-feedback"
                        onClick={this.handleSubmit}
                        disabled={!this.state.feedbackText}>
                        <FormattedMessage id="SD_SEND_SEARCH_RESULT_FEEDBACK_SEND" />
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

type TriggerProps = {
    searchFeedbackData: SearchFeedbackData;
};

type TriggerState = {
    showModal: boolean;
};

class CreateSearchResultFeedbackModalTrigger extends React.Component<TriggerProps, TriggerState> {
    state = { showModal: false };

    close = () => {
        this.setState({ showModal: false });
    };

    open = () => {
        this.setState({ showModal: true });
    };

    render() {
        if (this.props.searchFeedbackData.employeeId) {
            return (
                <>
                    <Button onClick={this.open} className="btn-default">
                        <FormattedMessage id="SD_SEND_SEARCH_RESULT_FEEDBACK_BUTTON" />
                    </Button>
                    <CreateSearchFeedbackModal
                        container={this}
                        show={this.state.showModal}
                        onClose={this.close}
                        searchFeedbackData={this.props.searchFeedbackData}
                    />
                </>
            );
        } else {
            return null;
        }
    }
}

export { CreateSearchResultFeedbackModalTrigger as Trigger, CreateSearchFeedbackModal as Modal };
export { SearchFeedbackData };
